

<div class="table-form-properties">

  @if (isCreateFormVisible) {
    <form [formGroup]="createForm">
      <div class="d-flex align-items-end">
        <div>
          <label class="me-2 fs-16 font-weight-600 mb-1">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.COLUMN' | translate }}</label>
          <input type="number" class="form-control me-2 mt-0 fs-14" formControlName="columns" inputSelectOnFocus>
        </div>
        <div>
          <label class="me-2 fs-16 font-weight-600 mb-1">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.ROW' | translate }}</label>
          <input type="number" class="form-control mt-0 fs-14" formControlName="rows" inputSelectOnFocus>
        </div>
        <button class="v-btn btn btn-primary vsight-button create-button ms-2" [disabled]="createForm.invalid" (click)="createTable()">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.CREATE-TABLE' | translate }}</button>
      </div>
      @if (createForm.controls['columns']?.errors?.['min']) {
        <p class="validation-text">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.COLUMN-VALIDATION-TEXT' | translate }}</p>
      }
      @if (createForm.controls['rows']?.errors?.['min']) {
        <p class="validation-text">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.ROW-VALIDATION-TEXT' | translate }}</p>
      }
    </form>
  }
  @if (isTableAvailable) {
    <div class="btn-toolbar" role="toolbar">
      <a (click)="addRow()" class="d-flex align-items-center add-button col-5 fs-14 font-weight-600">
        <img src="assets/img/add-circle-blue.svg" class="normal-icon">
        <img src="assets/img/add-circle-blue-hover.svg" class="hover-icon">
        <span class="ms-1 me-3">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.ADD-ROW' | translate }}</span>
      </a>
      <a (click)="deleteRow()" class="d-flex align-items-center add-button fs-14 font-weight-600" [ngClass]="{'a-disabled': data?.rows.length == 1}">
        <img src="assets/img/remove-circle-blue.svg" alt="" class="normal-icon">
        <img src="assets/img/remove-circle-blue-hover.svg" alt="" class="hover-icon">
        <span class="ms-1">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.DELETE-ROW' | translate }}</span>
      </a>
    </div>
    <div class="btn-toolbar top-gap-12" role="toolbar">
      <a (click)="addColumn()" class="d-flex align-items-center add-button col-5 fs-14 font-weight-600">
        <img src="assets/img/add-circle-blue.svg" class="normal-icon">
        <img src="assets/img/add-circle-blue-hover.svg" class="hover-icon">
        <span class="ms-1 me-3">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.ADD-COLUMN' | translate }}</span>
      </a>
      <a (click)="deleteColumn()" class="d-flex align-items-center add-button fs-14 font-weight-600" [ngClass]="{'a-disabled': data.columns[0].cells.length == 1}">
        <img src="assets/img/remove-circle-blue.svg" alt="" class="normal-icon">
        <img src="assets/img/remove-circle-blue-hover.svg" alt="" class="hover-icon">
        <span class="ms-1">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.DELETE-COLUMN' | translate }}</span>
      </a>
    </div>
    @if (data.columns[0].cells.length >= 7 || data.rows.length >= 5) {
      <div class="inform-text"><img src="assets/img/info.svg" alt=""> {{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.OPTIONS.MAX-ADDED' | translate }}</div>
    }
    <div class="table-form-properties-container">
      @if (!selectedCell) {
        <div class="info-container">
          <img src="assets/img/info_icon_blue.svg">
          <label class="label-span fs-12">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.SELECT-CELL-TEXT' | translate }}</label>
        </div>
      }
      @if (selectedCell) {
        <p class="selected-cell mb-2">
          <label class="fs-16 me-2 font-weight-600">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.SELECTED' | translate }}</label>
          <span class="fs-16">
            {{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.ROW' | translate }} {{selectedCell.row + 1}} {{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.COLUMN' | translate }} {{selectedCell.column + 1}}
          </span>
        </p>
      }
      @if (selectedCell) {
        <div class="cell-widget-selection">
          <!-- Hide widget type dropdown for header cells since they should only be labels -->
          @if (!selectedCell.isHeader) {
            <app-dropdown
                    [title]="tableWidgets[selectedCell.data.type]?.name
                        ? ((('MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.' + tableWidgets[selectedCell.data.type].name) | translate))
                        : ('MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.SELECT-CONTENT-TYPE-TEXT' | translate)">
              @for (widget of tableWidgets | objectToArray: 'type' ; track widget) {
                <a (click)="changeWidgetType(widget,selectedCell)" class="type-properties cursor-pointer fs-14">
                  {{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.' + widget.name  | translate }}
                </a>
              }
            </app-dropdown>
          }
          <!-- Show info text for header cells -->
          @if (selectedCell.isHeader) {
            <div class="header-cell-info mb-3">
              <div class="info-container">
                <img src="assets/img/info_icon_blue.svg">
                <label class="label-span fs-12">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.HEADER-CELL-INFO' | translate }}</label>
              </div>
            </div>
          }
          @if (selectedCell) {
            <app-widget-properties-form
              [data]="$safeNavigationMigration(selectedCell?.data)"
              (updated)="updateSelectedCellTemplateOptions($event)"
              [workflowTranslations]="workflowTranslations"
              (workflowTranslationsChange)="workflowTranslationsChange.emit($event)">
            </app-widget-properties-form>
          }
          @if (selectedCell && selectedCell?.data.type !=='empty' && !selectedCell.isHeader) {
            <button class="v-btn btn btn-primary mt-3 vsight-button create-button fs-14 mb-4"
            (click)="changeWidgetType({type:'empty',name:'Empty'},selectedCell, true )">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.CLEAR' | translate }}</button>
          }
        </div>
      }
    </div>
  }
</div>



<ng-template #createFormTemplate>
  <a (click)="isCreateFormVisible = true" class="add-button core-blue fs-12">
    <img src="assets/img/plus-circle.svg">
    <span class="ms-1">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.CREATE-TABLE' | translate }}</span>
  </a>

  @if (isCreateFormVisible) {
    <form class="d-flex align-items-center" [formGroup]="createForm">
      <span class="me-2 fs-12 font-weight-600">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.COLUMN' | translate }}</span>
      <input type="number" class="form-control me-2 mt-0" formControlName="columns" inputSelectOnFocus>
      <span class="me-2 fs-12 font-weight-600">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.TABLE.ROW' | translate }}</span>
      <input type="number" class="form-control mt-0" formControlName="rows" inputSelectOnFocus>
      <!-- <button class="btn btn-primary fs-12 font-weight-600 text-white ms-2" [disabled]="createForm.invalid" (click)="createTable()">Create</button> -->
    </form>
  }
</ng-template>